import { FAQ_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[FAQ_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'FAQ',
	},
}
